module.exports = __webpack_public_path__ + "static/img/04.b3e8446.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/peterschmid/04.jpg
// module id = 438
// module chunks = 1